import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### メッセージ送信の返信 API 操作クラス
 */
export default class SendMessageRepliesFamilies {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * Patch SendMessageRepliesFamilies
   */
  public async patch(
    userStore: LoginUser,
    datetime: number,
    residentId: number,
    familyId: number,
    replyDatetime: number,
    sendMessageRepliesFamily: SendMessageRepliesFamilyPatchModel
  ): Promise<SendMessageRepliesFamilyPatchModel> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      datetime: datetime,
      residentId: residentId,
      familyId: familyId,
      replyDatetime: replyDatetime
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendMessageRepliesFamilies, formatParams);
    const response = await this.commonService.executePatch<SendMessageRepliesFamilyPatchModel>(
      userStore,
      requestUrl,
      sendMessageRepliesFamily,
      this.constructor.name,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }
}

/**
 * ### メッセージ送信の返信
 */
export interface SendMessageRepliesFamilyPatchModel {
  /** 返信既読したユーザーID */
  readUserId: string;
  /** 返信既読したユーザー名 */
  readUserName: string;
  /** 既読／未読 */
  read: boolean;
  /** 返信メッセージ */
  message?: string;
  /** 利用者名 */
  residentName?: string;
  /** 利用者部屋名 */
  residentRoom?: string;
  /** 家族名 */
  familyName?: string;
  /** 家族電話番号 */
  familyTel?: string;
  /** 家族続柄 */
  familyRelation?: string;
  /** 家族役割 */
  familyPosition?: string;
}
